// runtime config, injected via public/env-config.js (dev) or generated at container
// start from env-config.template.js (preprod/prod) — see public/docker/entrypoint.sh
export default window.appConfig;
